import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Button, Dropdown } from "semantic-ui-react";

export function ConfirmationDropdown({
  items,
  initValue,
  loading,
  forceEnabled,
  placeholder,
  buttonLabel,
  onSelect,
  onChange,
  showSaveButton,
  forceSelectedValue,
  ...props
}) {
  const [selectedItem, setSelectedItem] = useState(initValue);

  useEffect(() => {
    if (forceSelectedValue) setSelectedItem(forceSelectedValue);
  }, [forceSelectedValue]);

  const checkDisable = () => {
    if (forceEnabled) return false;

    return (
      initValue === selectedItem &&
      items.some(({ key }) => {
        return initValue === key;
      })
    );
  };

  return (
    <React.Fragment>
      <Dropdown
        value={selectedItem}
        onChange={(_, { value }) => {
          setSelectedItem(value);

          if (showSaveButton) onChange(value);
          else onSelect(value);
        }}
        additionLabel={<b>+ Invite </b>}
        additionPosition="bottom"
        options={items}
        disabled={loading}
        loading={loading}
        searchInput={{ autoFocus: true }}
        fluid
        search
        placeholder={placeholder}
        selection
        selectOnBlur={false}
        style={{ minWidth: "200px" }}
        {...props}
      />
      {showSaveButton && (
        <Button
          disabled={loading || checkDisable()}
          loading={loading}
          fluid
          positive
          style={{ marginTop: "1em" }}
          onClick={(e) => {
            e.stopPropagation();
            onSelect(selectedItem);
          }}
        >
          {buttonLabel}
        </Button>
      )}
    </React.Fragment>
  );
}

ConfirmationDropdown.propTypes = {
  items: PropTypes.array,
  placeholder: PropTypes.string,
  buttonLabel: PropTypes.string,
  loading: PropTypes.bool,
  forceEnabled: PropTypes.bool,
  initValue: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  showSaveButton: PropTypes.bool,
  onChange: PropTypes.func,
  forceSelectedValue: PropTypes.string,
};

ConfirmationDropdown.defaultProps = {
  items: [],
  buttonLabel: "Save",
  placeholder: undefined,
  loading: false,
  forceEnabled: false,
  showSaveButton: true,
  forceSelectedValue: null,
  onChange: () => {},
};

export default ConfirmationDropdown;
